const s = {
  name: "StackOverflowLogo",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<polygon class="st0" points="25.8,24.9 8.2,21.2 7.5,24.7 25.1,28.4 	"/>
	<polygon class="st0" points="27.7,20.7 11.3,13.1 9.8,16.4 26.1,23.9 	"/>
	<polygon class="st0" points="30.5,17.1 16.6,5.7 14.3,8.4 28.2,19.9 	"/>
	<polygon class="st0" points="34,14.3 23.3,0 20.4,2.1 31.1,16.4 	"/>
	<rect x="7.2" y="29.3" class="st0" width="17.9" height="3.6"/>
	<polygon class="st0" points="28.7,36.4 3.6,36.4 3.6,25.8 0,25.8 0,40 32.3,40 32.3,25.8 28.7,25.8 	"/>
</g>
</svg>
  `
};
export {
  s as StackOverflowLogo
};
